import React from "react";

import { faSparkles } from "@fortawesome/pro-solid-svg-icons";

import { SuggestedActions } from "./SuggestedActions";

type FormBuilderSuggestedActionsProps = {
	onSelect: (query: string) => void;
};

export const FormBuilderSuggestedActions: React.FC<FormBuilderSuggestedActionsProps> = ({ onSelect }) => {
	return (
		<SuggestedActions
			actions={[
				{
					label: "Suggest questions for me",
					icon: faSparkles,
					onClick: () => onSelect("Suggest questions to ask"),
				},
			]}
		/>
	);
};
